import axios from 'axios'

export const COMPGROUPS_HAS_ERROR = 'COMPGROUPS_HAS_ERROR';
export const COMPGROUPS_IS_LOADING = 'COMPGROUPS_IS_LOADING';
export const COMPGROUPS_FETCH_DATA_SUCCESS = 'COMPGROUPS_FETCH_DATA_SUCCESS';
export const COMPGROUPS_CREATE_CACHE = 'COMPGROUPS_CREATE_CACHE';

export function compgroupsHasError(err) {
    return {
        type: COMPGROUPS_HAS_ERROR,
        error: err
    };
}

export function compgroupsIsLoading(bool) {
    return {
        type: COMPGROUPS_IS_LOADING,
        isLoading: bool
    };
}

export function compgroupsFetchDataSuccess(groups) {
    return {
        type: COMPGROUPS_FETCH_DATA_SUCCESS,
        groups
    };
}

export function compgroupsCreateCache(groups) {
    var groupsCache = groups.reduce(function(hash, value) {
        var key = value['id'];
        hash[key] = value.name;
        return hash;
      }, {});

    return {
        type: COMPGROUPS_CREATE_CACHE,
        groupsCache
    };
}

async function getData() {
    const res = await axios("/comp_group?sort=name");
    return res.data;
  }

export function fetchCompGroups() {
    return (dispatch) => {
        dispatch(compgroupsIsLoading(true));

        getData()
        .then(response => {
            dispatch(compgroupsIsLoading(false));
            dispatch(compgroupsFetchDataSuccess(response));
            dispatch(compgroupsCreateCache(response));
        })
        .catch(err => 
        {
            dispatch(compgroupsHasError(err));
        })
        }
    }

